export enum SortOrderType {
    Asc = 1,
    Des = -1,
    None = 0
}
